module.exports = __webpack_public_path__ + "static/media/cover.705b0673.png";